import notFound from "../../assets/images/svg/404.svg";
import homeBlueSmallcon from "../../assets/images/svg/homeBlueSmallcon.svg";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookie";
import { getUsersOffshoreValue } from "../../utils/functions";
import { OFFSHORE } from "../../utils/constants";
import { homePageRoute } from "../../utils/constants";
import PageHeading from "../../components/PageHeading/PageHeading";

const NotFound = () => {
  const navigate = useNavigate();
  const isLoggedIn = getCookie("token");

  const handleNavigation = () => {
    const isOffshoreOnly = getUsersOffshoreValue({}) === OFFSHORE;

    const navigationObj = {
      to: "",
      obj: {},
    };

    navigationObj.to = !isOffshoreOnly ? `/${homePageRoute}` : "/portfolio";
    navigationObj.obj = !isOffshoreOnly ? {} : { state: { from: OFFSHORE } };

    const { to, obj } = navigationObj;

    getCookie("token") ? navigate(to, obj) : navigate("/");
  };

  return (
    <div>
      <Header
        type={isLoggedIn ? homePageRoute : ""}
        isLogoNavigationEnabled={isLoggedIn ? true : false}
      />
      <div className="not_found_outer_main">
        <div className="not_found_inside_main">
          <img className="notFound" src={notFound} alt="No Data Found" />
          <p className="oops">Oops!</p>
          <PageHeading
            headingClass="nodata"
            headingText="We can't seem to find the page you are looking for!"
          />
          <div className="home_bottom" onClick={handleNavigation}>
            <img src={homeBlueSmallcon} alt="home" />{" "}
            <p>
              Go back to{" "}
              {isLoggedIn
                ? getUsersOffshoreValue({}) !== OFFSHORE
                  ? "Home"
                  : "Portfolio"
                : "Login"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
